// features/subscription/SubscriptionCancel.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../../components/ui/card';
import { FaTimesCircle } from 'react-icons/fa';

const SubscriptionCancel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigateToDashboard = () => {
    navigate('/subscription');
  };

  return (
    <Card className="w-full max-w-md mx-auto mt-10">
      <CardHeader className="text-center">
        <div className="flex justify-center mb-4">
          <FaTimesCircle className="text-amber-500 text-5xl" />
        </div>
        <CardTitle>{t('subscription.paymentCancelled')}</CardTitle>
        <CardDescription>{t('subscription.paymentCancelledDescription')}</CardDescription>
      </CardHeader>
      <CardContent className="text-center">
        <p>{t('subscription.noChargesMade')}</p>
        <p className="mt-2">{t('subscription.tryAgainMessage')}</p>
      </CardContent>
      <CardFooter className="flex justify-center">
        <Button onClick={handleNavigateToDashboard}>
          {t('subscription.returnToDashboard')}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default SubscriptionCancel;
